import { Stack, Typography } from '@mui/joy';

import { Level } from 'theme/enums';

export interface ITradeAgreementsNoRowsOverlayParams {
  message: string;
  reason?: string | null;
}

// The grid's own no-rows overlay, so the column headers and the toolbar stay while empty.
export const TradeAgreementsNoRowsOverlay = ({
  message,
  reason,
}: ITradeAgreementsNoRowsOverlayParams) => (
  <Stack sx={{ gap: 0.5, alignItems: 'center' }}>
    <Typography level={Level.BODY_MD}>{message}</Typography>

    {!!reason && (
      <Typography level={Level.BODY_SM} sx={{ color: 'text.tertiary' }}>
        {reason}
      </Typography>
    )}
  </Stack>
);
